import { ApiBaseParams } from './_base';

const businessRateCalculate = import.meta.env.VITE_APP_API_BUSINESS_RATE_CALCULATE;

export const calculateRate = async (params: ApiBaseParams) => {
  const apiUrl = params.url || businessRateCalculate || '';

  return await window.kfApi.postAsync(apiUrl, { localization: true }, params.data);
};
